import { Component, OnDestroy, OnInit, inject, input, OnChanges, SimpleChanges } from '@angular/core';
import {ChipModule} from "primeng/chip";
import {ButtonModule} from "primeng/button";
import {RippleModule} from "primeng/ripple";
import {DataView, DataViewModule} from "primeng/dataview";
import {InputTextModule} from "primeng/inputtext";
import {RatingModule} from "primeng/rating";
import {
    DataService,
    WriterResourceMatchType
} from "../../../service/data.service";
import {DialogModule} from "primeng/dialog";
import {BetaReaderStatus} from "../../../api/enums";
import {ResourceDetailComponent} from "../../resource-detail/resource-detail.component";
import {Project} from "../../../api/db/entities/Project";
import {SelectModule} from "primeng/select";
import { ProjectMatchType } from 'src/app/api/db/entities/ProjectMatchType';
import { ProjectProfileSelection } from 'src/app/api/db/entities/ProjectProfileSelection';

@Component({
    selector: 'writer-resource-matches',
    imports: [
    ChipModule,
    ButtonModule,
    RippleModule,
    DataViewModule,
    SelectModule,
    InputTextModule,
    RatingModule,
    DialogModule,
    ResourceDetailComponent
],
    templateUrl: './writer-resource-matches.component.html',
    styleUrl: './writer-resource-matches.component.scss'
})
export class WriterResourceMatchesComponent implements OnInit, OnChanges {
    private dataService = inject(DataService);


    readonly project = input<Project>(undefined);

    matchMeta: Map<string, {showDetail: boolean, tags: {label: string, icon: string}[]}> = new Map<string, {showDetail: boolean; tags: {label: string; icon: string}[]}>();
    sortOrder: number = 0;
    sortField: string = '';

    

    writerResourceMatchesArray: WriterResourceMatchType[] = [];

    projectMatchesRaw: ProjectMatchType[] = this.dataService.wMatchSignal();

    projectMatches: ProjectMatchType[] = [];


    ngOnInit(): void {

        /*console.log("RAW MATCHES", this.projectMatchesRaw);

        for(let i = 0; i < this.projectMatchesRaw.length; i++) {
            if (this.projectMatchesRaw[i].project.id == this.project().id) {
                this.projectMatches[i] = this.projectMatchesRaw[i];
            }
        }


        for(let i = 0; i < this.projectMatches.length; i++) {

           let tempGroup = this.projectMatches[i].betaReader.getProfileGroupForCode("FICTION_SERIES");

           let rawTags: {label: string, icon: string}[] = [];

           tempGroup.profileSelections.forEach((s: ProjectProfileSelection) => {
                if(s.categoryUniqueId == "GENRE" && s.value == "true") {
                    this.project().profileGroup.profileSelections.forEach((proj: ProjectProfileSelection) => {
                        if(proj.descriptorUniqueId == s.descriptorUniqueId && proj.value == "true") {
                            rawTags.push({label: s.descriptorUniqueId, icon: s.value})
                        }
                    });
                }
           });

            this.matchMeta.set(this.project().uuid, 
            {
                showDetail: false,
                tags: rawTags
            });
        }*/
    }

    ngOnChanges(changes: SimpleChanges): void {
        if(changes['project']) {
            
            this.projectMatches = [];

            console.log("RAW MATCHES", this.projectMatchesRaw);

            for(let i = 0; i < this.projectMatchesRaw.length; i++) {
                if (this.projectMatchesRaw[i].project.id == this.project().id) {
                    this.projectMatches.push(this.projectMatchesRaw[i]);
                }
            }


            for(let i = 0; i < this.projectMatches.length; i++) {

                console.log("SHOULD BE FILLED PROJECT MATCH", this.projectMatches);

                let tempGroup = this.projectMatches[i].betaReader.getProfileGroupForCode("FICTION_SERIES");

                let rawTags: {label: string, icon: string}[] = [];

                tempGroup.profileSelections.forEach((s: ProjectProfileSelection) => {
                        if(s.categoryUniqueId == "GENRE" && s.value == "true") {
                            this.project().profileGroup.profileSelections.forEach((proj: ProjectProfileSelection) => {
                                if(proj.descriptorUniqueId == s.descriptorUniqueId && proj.value == "true") {
                                    rawTags.push({label: s.descriptorUniqueId, icon: s.value})
                                }
                            });
                        }
                });

                this.matchMeta.set(this.project().uuid, 
                {
                    showDetail: false,
                    tags: rawTags
                });
            }
        }
    }


    onSortChange(event: any) {
        const value = event.value;

        if (value.indexOf('!') === 0) {
            this.sortOrder = -1;
            this.sortField = value.substring(1, value.length);
        } else {
            this.sortOrder = 1;
            this.sortField = value;
        }
    }

    onFilter(dv: DataView, event: Event) {
        dv.filter((event.target as HTMLInputElement).value);
    }

    protected readonly BetaReaderStatus = BetaReaderStatus;
    protected readonly Object = Object;
}
